import React, { Component } from 'react';
import { BrowserRouter, HashRouter, Route, Switch, Redirect, Link } from 'react-router-dom';
import { createBrowserHistory, createHashHistory } from "history";
// import logo from './logo.svg';
import './App.css';
import { connect } from "react-redux";
import RouteWithSubRoutes from './router/RouteWithSubRoutes';
import LoginRoutes from './router/LoginRoutes';
import { logError } from './helpers/auth';
// import imgUrl from "./assets/images/imageUrl.js";
import Services from "./api/api";
import Loader from './components/loaders/loader';
import OffileDb from './config/pouchDB';
import { createStore } from 'redux';
import reducer from './redux/reducers/appReducer';
import NetworkDetector from './Hoc/NetworkDetector';
import { getLsData, setLsData } from './service/lsencryption';
const store = createStore(reducer);
const loading = <div className="loading"></div>;

// const customHistory = createBrowserHistory();
const customHistory = createHashHistory();

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      templateID: 1,
      redirectTo: '',
      isLoading: false
    };
  }

  componentDidMount() {
    //this.getApptempaleID()  
    this.checkIfCommunityConfigured();
    var param = {
      communityid: this.props.communityuid,
    };
    console.log('getDashboardConfigurationByCommunityId params::', param)
    Services.getDashboardConfigurationByCommunityId(param).then((res) => {
      try{
        console.log("getDashboardConfigurationByCommunityId",res)
        if (res.data && res.data != 'null' && res.data.status == 200) {
          console.log('getDashboardConfigurationByCommunityId data', res.data.data)
          var cloundName = res.data.data.cloudinaryCloudName;
          var cloundPreset = res.data.data.cloudinaryPreset;
          OffileDb.setData("cloundName", res.data.data.cloudinaryCloudName);
          OffileDb.setData("cloundPreset", res.data.data.cloudinaryPreset);
          console.log('cloudName',cloundName,cloundPreset)
          setLsData("cloundName", res.data.data.cloudinaryCloudName)
          setLsData("cloundPreset", res.data.data.cloudinaryPreset)
          setLsData("isHybridModel", res.data.data.isHybridModel)
        }
      }catch(err){
        console.log("err::", err)
        var errorObj = {
          component: 'App',
          method: 'componentDidMount',
          error: err
        }
        logError(errorObj);
      }
    });
  }

  UNSAFE_componentWillMount() {
    customHistory.listen((location, action) => {
      //this.getAppLogos();
    });
  }

  checkIfCommunityConfigured() {
    const myState = store.getState();
    if (myState.communityId) {
      this.setState({ redirectTo: '/Onboarding' })
    } else {
      this.setState({ redirectTo: '/CommunityList' })
    }
  }

  getApptempaleID() {
    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
      };
      Services.getTemplatesByCommunityId(param).then((res) => {
        console.log(res)
        if(res.status != 200 || res == "Error: Network Error"){
          this.setState({
            isLoading:false
          })
        }
        if (res.status == 200) {
          console.log(res.data.data.templateList)
          var tempobj = res.data.data.templateList.filter(obj => obj.isDefault == true)[0]['templateId']
          this.setState({ templateID: tempobj })
          console.log(tempobj)
        }
      })
    }else{
      this.setState({
        isLoading:false
      })
    }
  }

  getContentListByCommunityId() {
    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
      };
      Services.contentListByCommunityId(param).then((res) => {
        console.log(res)
        if(res.status != 200 || res == "Error: Network Error"){
          this.setState({
            isLoading:false
          })
        }
        if (res.status == 200) {
          console.log(res.data.data.templateList)
          var tempobj = res.data.data.templateList.filter(obj => obj.isDefault == true)[0]['templateId']
          this.setState({ templateID: tempobj })
          console.log(tempobj)
        }
      })
    }else{
        this.setState({
          isLoading:false
        })
    }
  }

  getAppLogos() {
    var that = this;
    OffileDb.getData('applogos').then(function (result) {
      if (result.status && result.status == 404) {
        if (navigator.onLine) {
          var param = {
            communityId: that.props.communityuid,
          };
          Services.getCommunityBrandingByCommunityId(param).then((res) => {
            if(res.status != 200 || res == "Error: Network Error"){
              this.setState({
                isLoading:false
              })
            }
            if (res.status == 200) {
              OffileDb.setData('applogos', res.data.data)
            }
          })
        }else{
          this.setState({
            isLoading:false
          })
        }
      }
    });
  }


  render() {
    // var tempid = getLsData('templateID') || 1;
    return (
      <React.Suspense className="loaderreact" fallback={<Loader isLoading={true} />}>
        <HashRouter history={customHistory}>
          {
            <Switch>
              <Route
                exact
                path="/"
                render={() => {
                  return (
                    <Redirect to={this.state.redirectTo} />
                  )
                }}
              />
              {LoginRoutes.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
            </Switch>
          }
        </HashRouter>
      </React.Suspense>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    templateID: storeState.templateID,
    langId: storeState.langId,
  };
};
// export default connect(mapStateToProps, {})(NetworkDetector(App));
export default connect(mapStateToProps, {})(App);
//export default App;
